import {
  getInt32,
  getObject,
} from "@surya-digital/leo-ts-types";
import { ProjectSortOrder } from "./projectSortOrder";


export namespace GetArchivedSpocProjectsSortOrderEnums {
  /* eslint-disable @typescript-eslint/no-shadow */
  export namespace ColumnName {
    export enum ColumnName {
      PROJECT_NAME = "PROJECT_NAME",
      CREATED_ON = "CREATED_ON",
      LAST_MODIFIED = "LAST_MODIFIED",
    }
  
    export interface ColumnNameDTO {
      case: string;
    }
  
    export const fromDTO = (dto: ColumnNameDTO): ColumnName => {
      if (dto === undefined || dto === null) {
        throw new InvalidGetArchivedSpocProjectsSortOrderColumnNameError(
          `Invalid DTO ${dto} provided for ColumnName.ColumnName`
        );
      }
      switch (dto.case) {
        case "PROJECT_NAME":
          return ColumnName.PROJECT_NAME;
        case "CREATED_ON":
          return ColumnName.CREATED_ON;
        case "LAST_MODIFIED":
          return ColumnName.LAST_MODIFIED;
        default:
          throw new InvalidGetArchivedSpocProjectsSortOrderColumnNameError(
            `Case ${dto.case} is not valid case of ColumnName.ColumnName`
          );
      }
    };
  
    export const toDTO = (columnName: ColumnName): ColumnNameDTO => {
      const enumDTO = {
        case: ColumnName[columnName],
      };
      return enumDTO;
    };
  }
  
}
export interface GetArchivedSpocProjectsSortOrderDTO {
  sortIndex: number;
  columnName: GetArchivedSpocProjectsSortOrderEnums.ColumnName.ColumnNameDTO;
  order: ProjectSortOrder.ProjectSortOrderDTO;
}

export class GetArchivedSpocProjectsSortOrder {
  readonly isGetArchivedSpocProjectsSortOrderGetArchivedSpocProjectsSortOrder: boolean = true;

  readonly sortIndex: number;
  readonly columnName: GetArchivedSpocProjectsSortOrderEnums.ColumnName.ColumnName;
  readonly order: ProjectSortOrder.ProjectSortOrder;


  constructor(
  sortIndex: number, 
  columnName: GetArchivedSpocProjectsSortOrderEnums.ColumnName.ColumnName, 
  order: ProjectSortOrder.ProjectSortOrder
  ) {
    this.sortIndex = sortIndex;
    this.columnName = columnName;
    this.order = order;
  }

  static fromDTO(dto: GetArchivedSpocProjectsSortOrderDTO): GetArchivedSpocProjectsSortOrder {
    const sortIndex = getInt32(dto, "sortIndex", InvalidGetArchivedSpocProjectsSortOrderSortIndexError);
    const columnName = GetArchivedSpocProjectsSortOrderEnums.ColumnName.fromDTO(getObject(dto, "columnName", InvalidGetArchivedSpocProjectsSortOrderColumnNameError));
    const order = ProjectSortOrder.fromDTO(getObject(dto, "order", InvalidGetArchivedSpocProjectsSortOrderOrderError));
    return new GetArchivedSpocProjectsSortOrder(
      sortIndex,
      columnName,
      order
    );
  }

  toDTO(): GetArchivedSpocProjectsSortOrderDTO {
    const dto: GetArchivedSpocProjectsSortOrderDTO = {
        sortIndex: this.sortIndex,
        columnName: GetArchivedSpocProjectsSortOrderEnums.ColumnName.toDTO(this.columnName),
        order: ProjectSortOrder.toDTO(this.order)
    };
    return dto;
  }
  }

GetArchivedSpocProjectsSortOrder.prototype.toString = function toString(): string {
  return `GetArchivedSpocProjectsSortOrder(sortIndex='${this.sortIndex}',columnName='${this.columnName}',order='${this.order}')`;
};

export class InvalidGetArchivedSpocProjectsSortOrderError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedSpocProjectsSortOrderError";
  }
}
export class InvalidGetArchivedSpocProjectsSortOrderSortIndexError extends InvalidGetArchivedSpocProjectsSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedSpocProjectsSortOrderSortIndexError";
  }
}

export class InvalidGetArchivedSpocProjectsSortOrderColumnNameError extends InvalidGetArchivedSpocProjectsSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedSpocProjectsSortOrderColumnNameError";
  }
}

export class InvalidGetArchivedSpocProjectsSortOrderColumnNameProjectNameError extends InvalidGetArchivedSpocProjectsSortOrderColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedSpocProjectsSortOrderColumnNameProjectNameError";
  }
}

export class InvalidGetArchivedSpocProjectsSortOrderColumnNameCreatedOnError extends InvalidGetArchivedSpocProjectsSortOrderColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedSpocProjectsSortOrderColumnNameCreatedOnError";
  }
}

export class InvalidGetArchivedSpocProjectsSortOrderColumnNameLastModifiedError extends InvalidGetArchivedSpocProjectsSortOrderColumnNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedSpocProjectsSortOrderColumnNameLastModifiedError";
  }
}

export class InvalidGetArchivedSpocProjectsSortOrderOrderError extends InvalidGetArchivedSpocProjectsSortOrderError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGetArchivedSpocProjectsSortOrderOrderError";
  }
}
